<template>
  <div class="wall">
    <div class="wall-head flex-items-center">
      发货模版
      <el-button class="ml-auto" type="primary" size="small" round @click="handleCreate()">
        新增模版
      </el-button>
    </div>

    <div class="container mt-35 p-30">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="name" label="名称" />
        <el-table-column prop="areas" label="收货地址">
          <template slot-scope="scope">
            <span v-if="scope.row.areas.length === 34">全部地区</span>
            <span v-else>部分地区</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 弹窗 -->
    <el-dialog
      title="管理模板"
      :visible.sync="dialogVisible"
      width="840px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleClose">
      <rs-form ref="form" :model="formData" :errors="formErrors" :rules="rules" label-width="120px">
        <el-form-item label="模版名称" prop="name">
          <el-input v-model="formData.name"></el-input>
        </el-form-item>
        <!-- <el-form-item label="始发地" required>
          <el-select v-model="formData.area" placeholder="请选择地区">
            <el-option label="中国大陆" :value="1"></el-option>
            <el-option label="保税区" :value="2"></el-option>
            <el-option label="中国香港" :value="3"></el-option>
            <el-option label="澳洲" :value="4"></el-option>
            <el-option label="韩国" :value="5"></el-option>
            <el-option label="日本" :value="6"></el-option>
            <el-option label="美国" :value="7"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="身份证号码" required>
          <el-radio-group v-model="formData.need_card_code">
            <el-radio :label="false">不需要</el-radio>
            <el-radio :label="true">需要</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="身份证正反面" required>
          <el-radio-group v-model="formData.need_card_image">
            <el-radio :label="false">不需要</el-radio>
            <el-radio :label="true">需要</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="可发货地区">
          <div>
            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
            <div style="margin: 15px 0;"></div>
            <el-checkbox-group v-model="formData.areas" @change="handleCheckedCitiesChange">
              <el-checkbox style="width: 136px" v-for="city in cities" :label="city.id" :key="city.id">{{city.name}}</el-checkbox>
            </el-checkbox-group>
          </div>
        </el-form-item>
      </rs-form>
      <span slot="footer" class="dialog-footer">
        <el-button plain round class="main-btn" @click="handleClose">
          取 消
        </el-button>
        <el-button round class="main-btn ml-20" type="primary" @click="handleSubmit" :loading="dialogSubmitLoading">
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getArea, getDeliveries, createDelivery, updateDelivery } from '@/api/area';
const defaultAreas = [
  110000, 120000, 130000, 140000,
  310000, 320000, 330000, 340000, 350000, 360000, 370000,
  410000, 420000, 430000, 440000, 450000, 460000,
  500000, 510000, 520000, 530000,
  610000, 620000
];
export default {
  data() {
    return {
      dialogVisible: false,
      checkAll: false,
      formData: {
        areas: defaultAreas,
        area: 1,
        need_card_code: false,
        need_card_image: false
      },
      cities: [],
      isIndeterminate: true,
      dialogSubmitLoading: false,
      tableData: [],
      rules: {
        name: [
          { required: true, message: '名称不能为空', trigger: 'blur' }
        ],
      },
      formErrors: []
    }
  },
  created() {
    getArea().then(res => {
      this.cities = res || []
    })

    this.loadDelivery();
  },
  methods: {
    loadDelivery() {
      getDeliveries().then(res => {
        this.tableData = res.results || []
      })
    },
    handleCreate() {
      this.formData = {
        areas: defaultAreas,
        area: 1,
        id_no: 0,
        id_card: 0
      };
      this.dialogVisible = true;
    },
    handleEdit(row) {
      this.formData = row;
      this.dialogVisible = true;
    },
    handleSubmit() {

      this.$refs['form'].validate((valid) => {
        if (!valid) return false;

        this.dialogSubmitLoading = true;
        this.buildRequest().then(() => {
          this.dialogSubmitLoading = false;
          this.dialogVisible = false;
          this.loadDelivery();
        }).catch(err => {
          this.formErrors = err.data || [];
          this.dialogSubmitLoading = false;
        })
      });
    },
    buildRequest() {
      return this.formData.id
        ? updateDelivery(this.formData.id, this.formData)
        : createDelivery(this.formData);
    },
    handleClose() {
      this.dialogVisible = false;
      this.formData = {
        areas: defaultAreas,
        area: 1,
        id_no: 0,
        id_card: 0
      };
      this.$nextTick(() => {
        this.$refs['form'].resetFields();
      });
    },
    handleCheckAllChange(val) {
      this.formData.areas = val ? this.cities.map(res => {
        return res.id
      }) : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.cities.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
    }
  }
}
</script>
